// Scouting notes for keeper-relevant players. Data lives in
// `playerDescriptions.json`; refresh annually via
// `scripts/fill-descriptions.mjs` (see `scripts/generate-descriptions.md`).
// Lookups are case-insensitive.

import entries from './playerDescriptions.json';

function normalize(name) {
  return name
    .toLowerCase()
    .replace(/['’`]/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
}

export function getDescription(name) {
  if (!name) return null;
  return entries[normalize(name)] ?? null;
}

export function hasDescription(name) {
  return Boolean(getDescription(name));
}

export const DESCRIPTION_COUNT = Object.keys(entries).length;
